import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
});

// ── FDC Proxy ─────────────────────────────────────────────────────────────────

export const searchFdc = (q) =>
  axios.get(`${API_URL}/api/nutrition/fdc/search`, { ...authHeaders(), params: { q } })
    .then(r => r.data);

export const getFdcFood = (fdcId) =>
  axios.get(`${API_URL}/api/nutrition/fdc/${fdcId}`, authHeaders())
    .then(r => r.data);

// ── Ingredient Nutrition ──────────────────────────────────────────────────────

export const getIngredientNutrition = (ingredientId) =>
  axios.get(`${API_URL}/api/nutrition/ingredients/${ingredientId}`, authHeaders())
    .then(r => r.data);

export const saveIngredientNutrition = (ingredientId, data) =>
  axios.put(`${API_URL}/api/nutrition/ingredients/${ingredientId}`, data, authHeaders())
    .then(r => r.data);

export const importFromFdc = (ingredientId, fdcId = null) =>
  axios.post(`${API_URL}/api/nutrition/ingredients/${ingredientId}/fdc-import`,
    fdcId ? { fdcId } : {}, authHeaders())
    .then(r => r.data);

export const deriveFatProfile = (ingredientId, fdcId = null) =>
  axios.post(`${API_URL}/api/nutrition/ingredients/${ingredientId}/fdc-fat-profile`,
    fdcId ? { fdcId } : {}, authHeaders())
    .then(r => r.data);

// ── Product Nutrition Profile ─────────────────────────────────────────────────

export const getProductNutritionProfile = (productId) =>
  axios.get(`${API_URL}/api/nutrition/products/${productId}`, authHeaders())
    .then(r => r.data);

export const calculateNutrition = (productId, { servingSizeG, productWeightG, weightLossPct = 0 }) =>
  axios.post(`${API_URL}/api/nutrition/products/${productId}/calculate`,
    { servingSizeG, productWeightG, weightLossPct }, authHeaders())
    .then(r => r.data);

export const saveProductNutritionProfile = (productId, data) =>
  axios.put(`${API_URL}/api/nutrition/products/${productId}`, data, authHeaders())
    .then(r => r.data);

export const getIngredientCoverage = (productId) =>
  axios.get(`${API_URL}/api/nutrition/products/${productId}/ingredients-coverage`, authHeaders())
    .then(r => r.data);

export const getNutritionCertificate = (productId) =>
  axios.get(`${API_URL}/api/nutrition/products/${productId}/certificate`, authHeaders())
    .then(r => r.data);

// ── Nutrition Label Versions ──────────────────────────────────────────────────

export const getNutritionVersions = (productId) =>
  axios.get(`${API_URL}/api/nutrition/products/${productId}/versions`, authHeaders())
    .then(r => r.data);

export const approveNutritionVersion = (productId, notes = '') =>
  axios.post(`${API_URL}/api/nutrition/products/${productId}/versions/approve`,
    { notes }, authHeaders())
    .then(r => r.data);

export const getReconciliationAudit = () =>
  axios.get(`${API_URL}/api/nutrition/audit/reconciliation`, authHeaders())
    .then(r => r.data);

export const getNutritionReadiness = (productId) =>
  axios.get(`${API_URL}/api/nutrition/products/${productId}/readiness`, authHeaders())
    .then(r => r.data);

export const aiExtractNutrition = (ingredientId, docId) =>
  axios.post(`${API_URL}/api/nutrition/ingredients/${ingredientId}/ai-extract`, docId ? { docId } : {}, authHeaders())
    .then(r => r.data);

// AI sanity-check of vitamin D/calcium/iron/potassium against standard food-composition
// knowledge — flags a likely-omitted-by-supplier zero vs. a genuinely normal one.
export const checkNutritionPlausibility = (ingredientId) =>
  axios.post(`${API_URL}/api/nutrition/ingredients/${ingredientId}/plausibility-check`, {}, authHeaders())
    .then(r => r.data);
